export default __webpack_public_path__ + "static/media/login.5fcaeb03.svg";